module.exports = __webpack_public_path__ + "assets/202509252035/img/default.ce6f12ea.png";